<template>
  <div class="content library">    
    <loading v-if="loading" text='Stacking your shelf. Please wait...'/>
    <div v-show="!loading">
      <h1>Library</h1>
      <div class="right-tools no-select">
        <span class="sorting" v-on:click.stop="toggleSort()">Sort by Name <i v-if="reverseSort" class="fal fa-chevron-up"></i><i v-else class="fal fa-chevron-down"></i></span>

        <div v-on:click.stop="changeView()" class='icon-button' :title="listView ? 'Grid View' : 'List View'">
          <i class="fal" :class="{'fa-th-large': listView, 'fa-list' : !listView}"></i>
        </div>
      </div>
      <div style="clear: both;"></div>
    
      <!-- <div class="search">
        <span class="fal fa-search fa-lg"></span>
        <input type="text" name="search" v-model="search" autocomplete="off" placeholder="Search books" />
      </div> -->
      <Search v-on:searcher="onSearch" :placeholder="'Search books'">
      </Search>

      <Books
        v-if="bookList.length > 0"
        v-bind="{
          bookList,
          listView,
          reverseSort,
          search
        }"
      />

    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import storeHelpers from '@/utils/storeHelpers.js';
  import analytics from '@/utils/analytics.js'; 
  import Search from '@/components/widgets/Search';
  import Books from '@/components/library/Books';
  
  export default {
    name: 'Library',
    components: {
      Search,
      Books
    },
    data: function () {
      var t = this;

      return {
       loading: true,
       bookList: [],
       moment: moment,
       utils: utils,
       reverseSort: false,
       search: '',
       listView: true,
       unwatchFunctions: []
      }
    },
    destroyed: function() {
      _.each(this.unwatchFunctions, function(unwatchFunction) {
        unwatchFunction();
      });
    },
    mounted () {
      this.unwatchFunctions = utils.watchStorePropertiesWithCallback(this, ['bookList', 'resources', 'attachments'], this.booksUpdated);
      analytics.library(this);

      storeHelpers.checkActive(this);

      // check state if sort settings set
      var librarySettings = storeHelpers.getUserPreferences(this, "library");      
      if (librarySettings) {
        this.reverseSort = typeof librarySettings.reverseSort === 'undefined' ? false : librarySettings.reverseSort;
        this.listView = typeof librarySettings.listView === 'undefined' ? true : librarySettings.listView;
      }
    },
    methods: {
      booksUpdated: function() {
        var t = this;
        t.bookList = t.$store.state.bookList;

        // licenceExpiryDateTime test code
        // _.each(t.bookList, book => {
        //   if (book._id !== "epub-0bf7e090-162d-4f66-b106-a31a0658f802")
        //     book.licenceExpiryDateTime = moment().add(1, "months").unix();
        // })

        // todo
        // var availableGroupsKeyd = _.map(t.$store.state.groups, group => {
        //   return group.code
        // })
        // console.log('availableGroupsKeyd:', availableGroupsKeyd)
        // //filter booklist according to groups
        // t.bookList = _.filter(t.bookList, book => {
        //   if (book.groups.length == 0) return true
        //   var totalGroups = book.groups.length
        //   console.log(book, totalGroups)
        //   _.each(book.groups, group => {
        //     console.log("group", group)
        //     if (!_.includes(availableGroupsKeyd, group)) {
        //       totalGroups -= 1
        //     }
        //   })
        //   console.log("totalGroups", totalGroups)
        //   return totalGroups != 0
        // })

        
        const resourcesPerBook = storeHelpers.getResourcesPerBookNoAnnotations(this);

        _.each(this.bookList, function(book) {

          const unread = _.filter(resourcesPerBook[book.id], function(resourceWithAtt) {
            return resourceWithAtt.isUnread && !resourceWithAtt.resource.private;
          });
          
          Vue.set(book, 'unreadResources', unread.length);
        });

        this.loading = false;


        // need purchasing test code
        // _.each(this.bookList, function(book) {
        //   book.requirePurchase = true;
        // })
      },
      toggleSort: function () {
        this.reverseSort = !this.reverseSort;
        var libraryObj = {}
        libraryObj = {
          "reverseSort" : this.reverseSort,
          "listView" : this.listView
        }
        storeHelpers.setUserPreferences(this, "library", libraryObj);
      },
      onSearch: function (val) {
        this.search = val;
      },
      changeView: function() {
        this.listView = !this.listView
        var libraryObj = {}
        libraryObj = {
          "reverseSort" : this.reverseSort,
          "listView" : this.listView
        }
        storeHelpers.setUserPreferences(this, "library", libraryObj);
      }
    }
  }
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.library {
  .label-answer {
    display: inline-block;
  }
}
</style>